import { api, apiTest } from './config'
import request from './request'
import { getToken, setToken, removeToken } from '../store/auth'
import { method } from 'lodash'
var sha1 = require('sha1')
const auth = {
  headers: { Authorization: 'JWT ' + getToken() }
}

export default {
  administradorUnidade: {
    retornarAnuncios () {
      return request({
        url: '/administradorUnidade/retornarAnuncios',
        method: 'get'
      })
    },
    retornarMedicosExame (idExame) {
      return request({
        url: `/administradorUnidade/retornarMedicosExame/${idExame}`,
        method: 'get'
      })
    },
    cadastrarAnuncio (data) {
      return request({
        url: '/administradorUnidade/cadastrarAnuncio',
        method: 'post',
        data
      })
    },
    alterarAnuncio (data) {
      return request({
        url: '/administradorUnidade/alterarAnuncio',
        method: 'post',
        data
      })
    },

    // exame
    retornarExameHora (dataInicial, dataFinal) {
      return request({
        url: `/administradorUnidade/retornarExameHora/${dataInicial}/${dataFinal}`,
        method: 'get'
      })
    },

    // exame
    retornarInfoOS (os) {
      console.log(os)
      return request({
        url: `/administradorUnidade/retornarInfoOS/${os}`,
        method: 'get'
      })
    },
    retornarInfoSenhas () {
      return request({
        url: `/administradorUnidade/retornarInfoSenhas`,
        method: 'get'
      })
    },

    // exame Especialidade
    retornarExameEspexialidadeHora (dataInicial, dataFinal) {
      return request({
        url: `/administradorUnidade/retornarExameEspecialidadeHora/${dataInicial}/${dataFinal}`,
        method: 'get'
      })
    },

    retornarQuantSenhas24Horas () {
      return request({
        url: '/administradorUnidade/retornarQuantSenhas24h/',
        method: 'get'
      })
    },
    retornarQuantSenhasGeradas () {
      return request({
        url: '/administradorUnidade/retornarQuantSenhasGeradas/',
        method: 'get'
      })
    },
    retornarQuantAtendimentoStatus () {
      return request({
        url: '/administradorUnidade/retornarQuantAtendimentoStatus/',
        method: 'get'
      })
    },

    refreshToken (token) {
      // metodo do visor..
      // return api.post('/atendente/retornarChamadas',obj)
      return request({
        url: 'administradorUnidade/refreshToken',
        method: 'post',
        data: token
      })
    },

    tempoAtendimentoRecep (dataInicial, dataFinal) {
      return request({
        url: `/administradorUnidade/tempoAtendimentoRecep/${dataInicial}/${dataFinal}`,
        method: 'get'
      })
    },
    mediasTempoUnidade (dataInicial, dataFinal) {
      return request({
        url: `/administradorUnidade/mediasTempoUnidade/${dataInicial}/${dataFinal}`,
        method: 'get'
      })
    },

    /* tempoEsperaPacienteRecep (dataInicial, dataFinal) {
      return request({
        url: `/administradorUnidade/tempoEsperaPacienteRecep/${dataInicial}/${dataFinal}`,
        method: 'get'
      })
    }, */
    tempoEsperaDiaRecep (dataInicial, dataFinal) {
      return request({
        url: `/administradorUnidade/tempoEsperaDiaRecep/${dataInicial}/${dataFinal}`,
        method: 'get'
      })
    },

    retornarFuncionariosOnline () {
      return request({
        url: '/administradorUnidade/retornarFuncionariosOnline/',
        method: 'get'
      })
    },

    retornarHelp (tipo) {
      return request({
        url: `/administradorUnidade/retornarHelp/${tipo}`,
        method: 'get'
      })
    },

    retornarQuantFuncionariosOnline () {
      console.log('retornar dash no servico')
      // return api.get(`administradorUnidade/retornarQuantMedicosOnline/${idUnidade}`)
      return request({
        url: '/administradorUnidade/retornarQuantFuncionariosOnline/',
        method: 'get'
      })
    },
    cadastrarLocal (nomeLocal, automatico) {
      // console.log(id);
      var obj = {
        nomeLocal: nomeLocal,
        automatico: automatico
      }
      // return api.post('administradorUnidade/cadastrarLocal',obj)
      return request({
        url: '/administradorUnidade/cadastrarLocal/',
        method: 'post',
        data: obj
      })
    },

    retornarDashboard () {
      // return api.get(`administradorUnidade/retornarDashboard/${idUnidade}`)
      return request({
        url: '/administradorUnidade/retornarDashboard',
        method: 'get'
      })
    },

    retornarPaineisUnidade () {
      return request({
        url: '/administradorUnidade/paineis/config',
        method: 'get'
      })
    },

    atualizarPaineisUnidade (data) {
      return request({
        url: '/administradorUnidade/paineis/config',
        method: 'post',
        data
      })
    },

    cadastrarTokenUnidade (data) {
      return request({
        url: '/administradorUnidade/paineis/token',
        method: 'post',
        data
      })
    },

    temTokenCadastrado () {
      return request({
        url: '/administradorUnidade/paineis/token/status',
        method: 'get'
      })
    },

    atualizarStatusPainel (data) {
      return request({
        url: '/administradorUnidade/paineis/status',
        method: 'post',
        data
      })
    },

    listarPaineisApi () {
      return request({
        url: '/administradorUnidade/paineis/api',
        method: 'get'
      })
    },

    listarPaineisMongo () {
      return request({
        url: '/administradorUnidade/paineis/mongo',
        method: 'get'
      })
    },

    atualizarListaPaineis (data) {
      return request({
        url: '/administradorUnidade/paineis/lista',
        method: 'post',
        data
      })
    },

    retornarServicosMedico (idMedico) {
      // return api.get(`administradorUnidade/retornarServicosMedico/${idMedico}`)
      return request({
        url: `/administradorUnidade/retornarServicosMedico/${idMedico}`,
        method: 'get'
      })
    },

    desativarFuncionario (username, tipo) {
      // console.log(id);
      var obj = {
        username: username,
        tipo: tipo
      }
      // return api.post('administradorUnidade/desativarFuncionario',obj)
      return request({
        url: '/administradorUnidade/desativarFuncionario/',
        method: 'post',
        data: obj
      })
    },
    ativarFuncionario (username, tipo) {
      var obj = {
        username: username,
        tipo: tipo
      }
      // return api.post('administradorUnidade/ativarFuncionario',obj)
      return request({
        url: '/administradorUnidade/ativarFuncionario/',
        method: 'post',
        data: obj
      })
    },
    cadastrarAtendente (obj) {
      // console.log(id);
      // return api.post('administradorUnidade/cadastrarAtendente',obj)
      return request({
        url: '/administradorUnidade/cadastrarAtendente/',
        method: 'post',
        data: obj
      })
    },

    cadastrarUnidade (obj) {
      // console.log(id);
      // return api.post('administradorUnidade/cadastrarUnidade',obj)
      return request({
        url: '/administradorUnidade/cadastrarUnidade/',
        method: 'post',
        data: obj
      })
    },

    excluirFuncionario (obj) {
      // console.log(id);
      // return api.post('administradorUnidade/excluirFuncionario',obj)
      return request({
        url: '/administradorUnidade/excluirFuncionario/',
        method: 'post',
        data: obj
      })
    },

    cadastrarLocalFuncionario (obj) {
      // console.log(id);
      // return api.post('administradorUnidade/cadastrarLocalFuncionario',obj)
      return request({
        url: '/administradorUnidade/cadastrarLocalFuncionario/',
        method: 'post',
        data: obj
      })
    },

    cadastrarServicoMedico (obj) {
      // console.log(id);
      // return api.post('administradorUnidade/cadastrarServicoMedico',obj)
      return request({
        url: '/administradorUnidade/cadastrarServicoMedico/',
        method: 'post',
        data: obj
      })
    }, // retornarPossiveisRecepcionistas

    retornarPossiveisRecepcionistas (nome) {
      return request({
        url: `/administradorUnidade/retornarPossiveisRecepcionistas?nome=${nome}`,
        method: 'get'
      })
    },

    cadastrarRecepcionista (idRecepcionistas) {
      var obj = {
        idRecepcionistas: idRecepcionistas
      }
      return request({
        url: '/administradorUnidade/cadastrarRecepcionista/',
        method: 'post',
        data: obj
      })
    },

    retornarLocais () {
      // console.log(id);
      // return api.get('administradorUnidade/retornarLocais')
      return request({
        url: '/administradorUnidade/retornarLocais/',
        method: 'get'
      })
    },

    retornarVideos () {
      // console.log(id);
      // return api.get('administradorUnidade/retornarLocais')
      return request({
        url: '/administradorUnidade/retornarVideos/',
        method: 'get'
      })
    },

    retornarLocalMedico (idServico) {
      // console.log(id);
      // return api.get('administradorUnidade/retornarLocais')

      return request({
        url: `/administradorUnidade/retornarLocalMedico/${idServico}`,
        method: 'get'
      })
    },

    alterarLocal (idLocal, nomeLocal, automatico) {
      var obj = {
        idLocal: idLocal,
        nomeLocal: nomeLocal,
        automatico: automatico
      }
      // return api.post('administradorUnidade/alterarLocal/',obj)
      return request({
        url: '/administradorUnidade/alterarLocal/',
        method: 'post',
        data: obj
      })
    },

    retornarServicosSimplesMedic (idEmpresa) {
      var obj = {
        idEmpresa: idEmpresa
      }
      // return api.post('simplesMedic/unidadeServicos/',obj)
      return request({
        url: '/administradorUnidade/unidadeServicos/',
        method: 'post',
        data: obj
      })
    },

    retornarExameEspecialidade () {
      return request({
        url: '/administradorUnidade/retornarExameEspecialidade/',
        method: 'get'
      })
    },

    retornarVagaServico () { // feito
      return request({
        url: '/administradorUnidade/retornarVagaServico/',
        method: 'get'
      })
    },

    retornarServicosUnidade () { // feito
      // console.log(id);
      // return api.get('administradorUnidade/retornarServicosUnidade/'+idUnidade)
      return request({
        url: '/administradorUnidade/retornarServicosUnidade/',
        method: 'get'
      })
    },

    alterarPesoExame (exames) {
      console.log(exames)
      var obj = {
        exames: exames
      }
      // return api.post('administradorUnidade/alterarQuantidadeVagas/',obj)
      return request({
        url: 'administradorUnidade/alterarPesoExame/',
        method: 'post',
        data: obj
      })
    },

    alterarQuantidadeVagas (servicos) { // feito
      console.log(servicos)
      var obj = {
        servicos: servicos
      }
      // return api.post('administradorUnidade/alterarQuantidadeVagas/',obj)
      return request({
        url: 'administradorUnidade/alterarQuantidadeVagas/',
        method: 'post',
        data: obj
      })
    },

    retornarFuncionarios (tipo) {
      // return api.get(`administradorUnidade/retornarFuncionarios/${idUnidade}/${tipo}`)
      return request({
        url: `/administradorUnidade/retornarFuncionarios/${tipo}`,
        method: 'get'
      })
    },

    cadastrarFuncionario (idLocal, username, password, tipo, nome, isTelevisao, modoVisualizacao) {
      console.log('em servivo')

      var obj = {
        idLocal: idLocal,
        username: username,
        password: sha1(password),
        tipo: tipo,
        nome: nome,
        isTelevisao: isTelevisao,
        modoVisualizacao: modoVisualizacao
      }
      console.log('em servivo', obj)

      // return api.post('administradorUnidade/cadastrarFuncionario',obj)
      return request({
        url: 'administradorUnidade/cadastrarFuncionario',
        method: 'post',
        data: obj
      })
    },

    cadastraTecnicoServico (idMedico, servicos) {
      console.log('em servico cadastrar..')
      // console.log(servicos);
      console.log(servicos)
      // return;
      var obj = {
        idMedico: idMedico,
        servicos: servicos
      }
      return request({
        url: 'administradorUnidade/cadastrarMedicoServico',
        method: 'post',
        data: obj
      })
    },

    cadastrarMedicoServico (idMedico, servicos) {
      console.log('em servico cadastrar..')
      // console.log(servicos);
      console.log(servicos)
      // return;
      var obj = {
        idMedico: idMedico,
        servicos: servicos
      }
      // return api.post('administradorUnidade/cadastrarMedicoServico',obj)
      return request({
        url: 'administradorUnidade/cadastrarMedicoServico',
        method: 'post',
        data: obj
      })
    },

    alterarSenhaAdministrador (senhaAtual, novaSenha, tipo, username) {
      var obj = {
        senhaAtual: sha1(senhaAtual),
        novaSenha: sha1(novaSenha),
        username: username,
        tipo: tipo
      }
      // return api.post('/administradorUnidade/alterarSenha',obj)
      return request({
        url: 'administradorUnidade/alterarSenha',
        method: 'post',
        data: obj
      })
    },

    alterarNomeAdministradorUnidade (nome, username, tipo) {
      var obj = {
        nome: nome,
        username: username,
        tipo: tipo
      }
      // return api.post('/administradorEmpresa/alterarNomeAdministrador',obj) // essa rota usa admempresa
      return request({
        url: 'administradorUnidade/alterarNomeAdministrador',
        method: 'post',
        data: obj
      })
    },

    alterarFuncionario (idLocal, nome, tipo, username, password, isTelevisao, volume, video, modoVisualizacao, anuncios, idFuncionario) {
      var passwordAux = password == '' ? null : sha1(password)
      var obj = {
        idLocal: idLocal,
        nome: nome,
        tipo: tipo,
        username: username,
        password: passwordAux,
        isTelevisao: isTelevisao,
        volume: volume,
        video: video,
        modoVisualizacao: modoVisualizacao,
        anuncios: anuncios,
        idFuncionario: idFuncionario
      }
      // return api.post('/administradorUnidade/alterarFuncionario', obj)
      return request({
        url: 'administradorUnidade/alterarFuncionario',
        method: 'post',
        data: obj
      })
    },

    alterarServico (idUnidade, idServico, idLocal, idMedicoTecnico, idLocaisMedico, diasSemana, peso, exibirAtendente, idMedicos, idTecnicos) {
      var obj = {
        idUnidade: idUnidade,
        idServico: idServico,
        idLocal: idLocal,
        idMedicoTecnico: idMedicoTecnico,
        diasSemana: diasSemana,
        idLocaisMedico: idLocaisMedico,
        exibirAtendente: exibirAtendente,
        peso: peso,
        idMedicos: idMedicos,
        idTecnicos: idTecnicos
      }
      console.log('obj em servico..', obj)
      return request({
        url: 'administradorUnidade/alterarServico',
        method: 'post',
        data: obj
      })
    },

    cadastrarServico (data) {
      console.log('cadastrar --- ', data)
      return request({
        url: '/administradorUnidade/cadastrarServico/',
        method: 'post',
        data: data
      })
    },
    retornarTodosMedicos () {
      return request({
        url: '/administradorUnidade/retornarTodosMedicos/',
        method: 'get'
      })
    },

    retornarPossiveisTecnicos () {
      return request({
        url: '/administradorUnidade/retornarPossiveisTecnicos/',
        method: 'get'
      })
    },

    retornarMedicoTecnico (idServico) {
      return request({
        url: `administradorUnidade/retornarMedicoTecnico/${idServico}`,
        method: 'get'
      })
    },

    retornarMedicosOnline () {

    },

    importarRecepcionistas () {
      return request({
        url: '/administradorUnidade/importarRecepcionistas/',
        method: 'get'
      })
    },

    importarTecnicos () {
      return request({
        url: '/administradorUnidade/importarTecnicos/',
        method: 'get'
      })
    },

    retornarExames (idExameEspecialidade) {
      return request({
        url: `administradorUnidade/retornarExames/${idExameEspecialidade}`,
        method: 'get'
      })
    },

    retornarExamesParent (idExameEspecialidade, parent, nomeExame = null) {
      const params = new URLSearchParams()

      if (idExameEspecialidade !== null && idExameEspecialidade !== undefined && idExameEspecialidade !== '') {
        params.append('idExameEspecialidade', idExameEspecialidade)
      }

      if (parent !== null && parent !== undefined && parent !== '') {
        params.append('parent', parent)
      }

      if (nomeExame && nomeExame.trim() !== '') {
        params.append('nomeExame', nomeExame.trim())
      }

      const queryString = params.toString()
      const url = `administradorUnidade/retornarExamesParent${queryString ? `?${queryString}` : ''}`
      console.log('url: ', url)
      
      return request({
        url: url,
        method: 'get'
      })
    },

    retornarExamesMedico (idServico, idMedico) {
      return request({
        url: `administradorUnidade/retornarExamesMedico/${idServico}/${idMedico}`,
        method: 'get'
      })
    },

    retornarExamesMedicoParent (idServico, idMedico, parent) {
      console.log(idServico, idMedico, parent)

      return request({
        url: `administradorUnidade/retornarExamesMedicoParent?idServico=${idServico}&idMedico=${idMedico}&parent=${parent}`,
        method: 'get'
      })
    },

    cadastrarExameMedico (idMedico, idMedicoServico, exames, idServico) {
      console.log('info medico: ', idMedico, idMedicoServico, exames, idServico)

      var obj = {
        idMedico: idMedico,
        idMedicoServico: idMedicoServico,
        idServico: idServico,
        exames: exames
      }
      console.log(obj)

      return request({
        url: 'administradorUnidade/cadastrarExameMedico',
        method: 'post',
        data: obj
      })
    },

    importarMedico (idUnidade, codigo) {
      var obj = {
        idUnidade: idUnidade,
        codigo: codigo
      }
      return request({
        url: '/administradorUnidade/importarMedico',
        method: 'post',
        data: obj
      })
    },
    alterarCor (cor) {
      var obj = {
        cor: cor
      }
      return request({
        url: 'administradorUnidade/alterarCor',
        method: 'post',
        data: obj
      })
    },

    retornarCor () {
      return request({
        url: 'administradorUnidade/retornarCor',
        method: 'get'
      })
    },
    cadastrarPacoteExame (idPacote, nome, exames, idUnidade, sadt, ativo) {
      console.log('-----> ', exames)
      var obj = {
        idUnidade: idUnidade,
        nome: nome,
        exames: exames,
        idPacote: idPacote,
        sadt: sadt,
        ativo: ativo
      }
      return request({
        url: '/administradorUnidade/cadastrar-pacote-exame',
        method: 'post',
        data: obj
      })
    },
    listarPacoteExames (idUnidade, sadt) {
      return request({
        url: `/administradorUnidade/listar-pacotes?idUnidade=${idUnidade}&sadt=${sadt}`,
        method: 'get'
      })
    },
    listarEmpresas () {
      return request({
        url: '/administradorUnidade/listarempresas',
        method: 'get'
      })
    },
    // Listar unidades por idEmpresa
    listarUnidades (idEmpresa) {
      return request({
        url: `/administradorUnidade/listarunidades?idEmpresa=${idEmpresa}`,
        method: 'get'
      })
    },
    retornarVoucher () {
      return request({
        url: `/administradorUnidade/retornarVoucher`,
        method: 'get'
      })
    },
    atualizarVoucher (voucher) {
      const data = { voucher: voucher }
      return request({
        url: '/administradorUnidade/atualizarVoucher',
        method: 'post',
        data
      })
    }
  }
}
